import { Wrapper, Path } from "./styles/TerminalInfo.styled";

const TermInfo = () => {
  return (
    <Wrapper>
      <Path>C:\Users\Asilbek</Path>&gt;
    </Wrapper>
  );
};

export default TermInfo;
